<template>
    <ModalComponent
        name="descargar-informe"
        title="Descargar informe en excel"
        @close="() => close(false)"
    >
        <div v-if="! loading">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                <div class="card-body">
                    <b-row>
                        <b-col cols="12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de inicio</label>
                                <datetime 
                                    v-model="data.fecha_inicio"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                />
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="form-group">
                                <label for="fecha_envio">Fecha de fin</label>
                                <datetime 
                                    v-model="data.fecha_fin"
                                    input-class="form-control"
                                    type="date"
                                    input-id="fecha_inicio"
                                />
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox" id="only_taquilla" v-model="data.only_taquilla" />
                                <label for="only_taquilla" class="custom-control-label pt-1">Filtrar solo {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "terrenos vendidos" : "parcelas vendidas" }} en taquilla</label>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox" id="only_online" v-model="data.only_online" />
                                <label for="only_online" class="custom-control-label pt-1">Filtrar solo {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "terrenos vendidos" : "parcelas vendidas" }} online</label>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="text-right">
                    <Button type="submit">DESCARGAR</Button>
                </div>
            </ValidationObserver>
        </div>
        <template v-else>
            <div class="m-0">
                <div class="p-4 m-2">                    
                    <div class="row">
                        <h2>Se esta generando el informe, recibirá una notificación para poder descargarlo cuando esté listo.</h2>
                    </div>
                </div>
            </div>
        </template>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        data() {
            return {
                loading: false,
                data: {
                    fecha_inicio: null,
                    fecha_fin: null,
                    only_taquilla: false,
                    only_online: false
                }
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid) {
                    this.getInforme();
                }
            },
            getInforme() {
                this.loading = true;
                const params = {
                    filters : {
                        fecha_inicio: this.data.fecha_inicio,
                        fecha_fin: this.data.fecha_fin,
                        only_taquilla: this.data.only_taquilla ? 1 : 0,
                        only_online: this.data.only_online ? 1 : 0
                    },
                    lista_id: this.lista.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.parcelas.informe.excel'), params).then(res => {
                    this.loading = true;
                });
            },
            close() {
                this.loading = false;
                this.$emit('close', 'descargar-informe');
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        components: {
            ModalComponent
        }
    }
</script>